import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fileUrl } from "@/components/ImageUpload";
import { PAYMENT_STATUS_META } from "@/lib/tournament";
import { FileText, ExternalLink, User } from "lucide-react";

const PAY = ["pending", "confirmed", "paid", "paid_confirmed"];

export default function SubmissionInspector({ open, onClose, reg, fields = [], onStatus }) {
  if (!reg) return null;
  const resp = reg.custom_responses || {};
  const answered = (fields || []).filter((f) => f.type !== "header");

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass max-h-[85vh] overflow-y-auto" style={{ background: "var(--surface-glass)" }} data-testid="submission-inspector">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><User className="w-5 h-5 text-primary-c" /> {reg.player_name || "Player"}</DialogTitle>
          <DialogDescription style={{ color: "var(--text-2)" }}>{reg.category_label || "—"} · {reg.player_email || "no email on file"}</DialogDescription>
        </DialogHeader>

        <div>
          <div className="text-[10px] uppercase tracking-wider mb-1.5" style={{ color: "var(--text-2)" }}>Registration status</div>
          <div className="flex items-center gap-2" data-testid="inspector-status">
            {PAY.map((s) => {
              const active = reg.payment_status === s;
              const m = PAYMENT_STATUS_META[s] || { l: s, color: "var(--text-2)" };
              return (
                <button key={s} data-testid={`inspector-status-${s}`} onClick={() => onStatus(s)}
                  className={`rounded-full px-3 py-1.5 text-xs font-bold ${active ? "btn-glow" : "glass"}`} style={active ? {} : { color: m.color }}>
                  {m.l}
                </button>
              );
            })}
          </div>
        </div>

        {reg.payment_proof_url && (
          <div>
            <div className="text-[10px] uppercase tracking-wider mb-1.5" style={{ color: "var(--text-2)" }}>Payment proof</div>
            <a href={fileUrl(reg.payment_proof_url)} target="_blank" rel="noreferrer" data-testid="inspector-proof">
              <img src={fileUrl(reg.payment_proof_url)} alt="payment proof" className="w-32 h-32 object-cover rounded-lg glow-border" />
            </a>
          </div>
        )}

        <div>
          <div className="text-[10px] uppercase tracking-wider mb-1.5" style={{ color: "var(--text-2)" }}>Custom responses</div>
          {answered.length === 0 ? (
            <p className="text-sm" style={{ color: "var(--text-2)" }}>This event has no custom registration questions.</p>
          ) : (
            <div className="space-y-2" data-testid="inspector-answers">
              {answered.map((f) => {
                const v = resp[f.id];
                return (
                  <div key={f.id} data-testid={`inspector-answer-${f.id}`} className="rounded-xl p-3" style={{ background: "var(--bg)" }}>
                    <div className="text-[10px] uppercase tracking-wider" style={{ color: "var(--text-2)" }}>{f.label}</div>
                    {!v ? (
                      <div className="text-sm italic mt-1" style={{ color: "var(--text-2)" }}>Not provided</div>
                    ) : f.type === "image" ? (
                      <a href={fileUrl(v)} target="_blank" rel="noreferrer">
                        <img src={fileUrl(v)} alt={f.label} className="mt-2 w-32 h-32 object-cover rounded-lg glow-border" />
                      </a>
                    ) : f.type === "file" ? (
                      <a href={fileUrl(v)} target="_blank" rel="noreferrer" className="mt-1 inline-flex items-center gap-1.5 text-sm" style={{ color: "var(--primary-ink)" }}>
                        <FileText className="w-4 h-4" /> Download file <ExternalLink className="w-3 h-3" />
                      </a>
                    ) : (
                      <div className="text-sm mt-1 whitespace-pre-wrap" style={{ color: "var(--text)" }}>{v}</div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
